const en = {
    l: {
        en: "English",
        th: "ไทย",
        lo: "ลาว"
    },
    language: "Language",
    lang : "English",
    signIn : "Sign In",
    fill_user_pass : "Please Input Member Information",
    logout : "Logout",
    register : "Register",
    menu: {
        dashboard: "Dashboard",
        init_doc: "Initial Pack",
        shipment_check: "Shipment Check",
        ship_parcel: "Ship Parcel",
        drop_parcel: "Drop Parcel",
        move_parcel: "Move Parcel",
        drop_image_confirm: "Ticket Approve",
    },
    dashboard : {
        advance_money_balance: "Advance Money Balance",
        point_balance: "Point Balance",
        advance_money_transection: "Advance Money Transection",
        point_transection: "Point Transection",
        nodata: "No Information",
        today_packing: "Today Pack",
        today_picking: "Today Pick"
    },
    trans_flag: {
        trans_flag_40 : "Advance Money",
        trans_flag_44 : "Sales"
    },
    profile: {
        name: "Name",
        username: "Username",
        password: "Password",
        email: "Email",
        change_password: "Change Password",
        current_password: "Currrent Password",
        new_password: "New Password",
        confirm_password: "Confirm Password",
        not_scure_password: "Password not scure. Please change password",
        confirm_password_invalid: "Confirm password invalid.",
        input_invalid: "Input Invalid"
    },
    common: {
        save: "Save",
        save_success: "Save successfully.",
        save_fail: "Save failed."
    },
    Boxs: "Boxs",
    Sended: "Sended"
}

export default en